import React from 'react';
import PropTypes from 'prop-types';
import CurrentZoneIndicator from '../../components/CurrentZoneIndicator';
import ValueTicketConfirmationScreen from './components/ValueTicketConfirmationScreen';
import ExtraTicketConfirmationScreen from './components/ExtraTicketConfirmationScreen';
import SeasonalTicketConfirmationScreen from './components/SeasonalTicketConfirmationScreen';
import AdditionalZoneConfirmationScreen from './components/AdditionalZoneConfirmationScreen';
import {
  TICKET_TYPE_VALUE_TICKET,
  TICKET_TYPE_EXTRA_TICKET,
  TICKET_TYPE_SEASONAL_TICKET,
  TICKET_TYPE_ADDITIONAL_ZONE,
} from '../../constants';

const ConfirmationScreenContent = ({
  currentZone,
  ticketType,
  remainingFunds,
  valueTicket,
  seasonalTicket,
  additionalZoneTicket,
}) => (
  <>
    <CurrentZoneIndicator white>{currentZone[0]}</CurrentZoneIndicator>
    {ticketType === TICKET_TYPE_VALUE_TICKET && (
      <ValueTicketConfirmationScreen
        zones={valueTicket.zones}
        passengers={valueTicket.passengers}
        validityEndsAtString={valueTicket.validityEndsAtString}
        price={valueTicket.price}
        remainingFunds={remainingFunds}
      />
    )}
    {ticketType === TICKET_TYPE_EXTRA_TICKET && (
      <ExtraTicketConfirmationScreen
        seasonalTicket={seasonalTicket}
        valueTicket={valueTicket}
        remainingFunds={remainingFunds}
      />
    )}
    {ticketType === TICKET_TYPE_SEASONAL_TICKET && (
      <SeasonalTicketConfirmationScreen
        zones={seasonalTicket.zones}
        validityEndsAtString={seasonalTicket.validityEndsAtString}
        remainingFunds={remainingFunds}
      />
    )}
    {ticketType === TICKET_TYPE_ADDITIONAL_ZONE && (
      <AdditionalZoneConfirmationScreen
        additionalZoneTicket={additionalZoneTicket}
        seasonalTicket={seasonalTicket}
        valueTicket={valueTicket}
        remainingFunds={remainingFunds}
      />
    )}
  </>
);

ConfirmationScreenContent.propTypes = {
  currentZone: PropTypes.string.isRequired,
  ticketType: PropTypes.string.isRequired,
  remainingFunds: PropTypes.number.isRequired,
  valueTicket: PropTypes.shape({
    zones: PropTypes.string.isRequired,
    passengers: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    validityEndsAtString: PropTypes.string.isRequired,
  }),
  seasonalTicket: PropTypes.shape({
    zones: PropTypes.string.isRequired,
    validityEndsAtString: PropTypes.string.isRequired,
  }),
  additionalZoneTicket: PropTypes.shape({
    zone: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    validityEndsAtString: PropTypes.string.isRequired,
  }),
};

ConfirmationScreenContent.defaultProps = {
  valueTicket: null,
  seasonalTicket: null,
  additionalZoneTicket: null,
};

export default ConfirmationScreenContent;
